var map = {
	"./image-25.png": 86,
	"./image-26.png": 87,
	"./image-34.png": 88,
	"./image-35.png": 89,
	"./image-36.png": 90,
	"./image-37.png": 91,
	"./image-38.png": 92,
	"./image-39.png": 93,
	"./image-40.png": 94,
	"./image-41.png": 95,
	"./image-42.png": 96,
	"./image-43.png": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;